import { render, staticRenderFns } from "./ziCiRenDu.vue?vue&type=template&id=356e27fa&scoped=true&"
import script from "./ziCiRenDu.vue?vue&type=script&lang=js&"
export * from "./ziCiRenDu.vue?vue&type=script&lang=js&"
import style0 from "./ziCiRenDu.vue?vue&type=style&index=0&id=356e27fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e27fa",
  null
  
)

export default component.exports